module.exports = __webpack_public_path__ + "img/icon-water-level-pond.ac81075f.png";